import React from "react";
import { GSForm, GSSidePanelPage, GSEmptyList } from "golfstatus_react_components";
import { faChevronLeft, faPlus } from "@fortawesome/free-solid-svg-icons";
import { useMatch, useNavigate } from "react-router-dom";

//import scss
import "./tournament-settings-payments-customer-invoice-watch.scss";
import { useFormDataValidation } from "../../../hooks/formHooks";
import { useNotificationBanner } from "../../../hooks/notificationHooks";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { customerInvoiceWatchEmailsForm } from "../../../forms/SettingsForms";
import {
  clearTournamentNotifications,
  getTournamentCustomerInvoiceWatchEmails,
  selectTournamentNotifications,
  setCurrentTournamentCustomerInvoiceWatchEmail,
  setCurrentTournamentCustomerInvoiceWatchEmails,
  selectCurrentCustomerInvoiceWatchEmails,
} from "../../../reducers/tournamentSlice";
import { useState } from "react";

//Name the component
const TournamentSettingsPaymentsCustomerInvoiceWatch = (props) => {
  // search
  const [search, setSearch] = useState("");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const match = useMatch("/:tournamentID/settings/payments/customer-invoice-watch");
  const notifications = useSelector(selectTournamentNotifications);

  const currentTournamentCustomerInvoiceWatchEmails = useSelector(selectCurrentCustomerInvoiceWatchEmails);

  const [context] = useFormDataValidation({
    initialValid: true,
    data: currentTournamentCustomerInvoiceWatchEmails,
    setData: setCurrentTournamentCustomerInvoiceWatchEmails,
  });

  context.getFilteredWatchEmails = () => {
    return currentTournamentCustomerInvoiceWatchEmails?.filter?.((wi) =>  wi.email?.toLowerCase?.().includes?.(search?.toLowerCase?.()));
  };

  context.getSearch = () => {
    return { search, setSearch };
  };

  context.addWatchEmail = () => {
    dispatch(setCurrentTournamentCustomerInvoiceWatchEmail({}));
    navigate("add");
  };

  context.editWatchEmail = (watchEmail) => {
    navigate(`${watchEmail.id}`);
  };

  context.getEmptyMessage = () => {
    if(search === ""){
      return <GSEmptyList title="Invoice Watch Emails"
      detail="Everyone on this list will be notified when an invoice has been created."
      actions={[
        {
          title: "Add Email",
          buttonIcon: faPlus,
          onClick: context.addWatchEmail,
          type: "black",
        },
      ]}/>
    }

    return <GSEmptyList title="We couldn’t find the email address you’re looking for…"
    detail="Try changing the search term or add a new email address."
    actions={[
      {
        title: "Clear Search",
        onClick: () => {
          setSearch("");
        },
        type: "light-grey",
      },
      {
        title: "Add Email",
        buttonIcon: faPlus,
        onClick: context.addWatchEmail,
        type: "black",
      },

    ]}/>

  }

  useEffect(() => {
    if (match?.params?.tournamentID) {
      dispatch(getTournamentCustomerInvoiceWatchEmails(match.params.tournamentID));
    }
  }, [dispatch, match?.params?.tournamentID]);

  const leftNavigation = () => {
    navigate(-1);
  };

  const getNavigation = () => {
    //Add Title to your component
    return {
      title: `Invoice Watch Emails`,
      leftIcon: faChevronLeft,
      leftButtonClick: leftNavigation,
    };
  };

  const getFormActions = () => {
    return [
      {
        title: "add email",
        type: "black no-wrap mobile-icon",
        actionIcon: faPlus,
        actionClick: context?.addWatchEmail,
      },
    ];
  };

  const getContent = () => {
    return (
      <GSForm
        formTitle="Invoice Watch Emails"
        formActions={getFormActions()}
        formSections={customerInvoiceWatchEmailsForm(context)}
      ></GSForm>
    );
  };

  const timeoutAction = () => {
    dispatch(clearTournamentNotifications());
  };

  const [banner] = useNotificationBanner({ notifications, timeoutAction });

  return (
    //name the component tag
    <tournament-settings-payments-customer-invoice-watch>
      <GSSidePanelPage
        header={getNavigation()}
        banner={banner}
        content={getContent()}
      ></GSSidePanelPage>
    </tournament-settings-payments-customer-invoice-watch>
  );
};

//export the new name
export default TournamentSettingsPaymentsCustomerInvoiceWatch;
